/** @file scopePartialWarning: SCOPE_PARTIAL, an entry a scope's direction count could not narrow. */
import type { Warning, WarningCode } from '@zilo/pose3d-format/types/warning';

/**
 * `SCOPE_PARTIAL` is not in the frozen `WarningCode` union yet (format/types/warning.ts); the widening cast stays
 * here, in one place, until a contract request adds the code.
 */
const SCOPE_PARTIAL = 'SCOPE_PARTIAL' as string as WarningCode;

/** The warning for entry `entry` of drawable `drawable` (index `index`), left on `table` wider than `directions`. */
export function scopePartialWarning(drawable: string, index: number, entry: number, table: string, directions: number): Warning {
  return {
    code: SCOPE_PARTIAL, path: `/puppet/drawables/${String(index)}/facets/${String(entry)}/yaw`, params: { drawable, entry, table, directions },
    message: `${drawable} entry ${String(entry)} keeps table ${table}: it has no built-in member with ${String(directions)} directions`,
    hint: `facet.setTable it to a table of ${String(directions)} directions, or leave it wider`,
  };
}
